export default [
  {
    path: '/support/price-change-requests',
    name: 'PriceChangeRequestList',
    component: () => import('@/views/support/price-change-requests/PriceChangeRequestList.vue'),
    meta: {
      title: 'Demandes de modification de prix',
      pageTitle: 'Liste des demandes de modification de prix',
      pageDesc: 'Consultez et gérez les demandes de modification de prix pour les commandes.',
      icon: 'mdi-currency-usd',
      roles: ['admin', 'superadmin', 'manager', 'warehouse_operator', 'customer_support', 'supplier'],
      requireLogin: true,
      accessibility: {
        ariaLabel: 'Liste des demandes de modification de prix',
        breadcrumbLabel: 'Fil d\'Ariane des demandes de modification de prix',
      },
      breadcrumb: [
        { text: 'Support', to: { name: 'SupportTicketList' }, ariaLabel: 'Accueil support' },
        { text: 'Demandes de modification de prix', active: true, ariaLabel: 'Demandes de modification de prix' },
      ],
    },
  },
  {
    path: '/support',
    name: 'SupportTicketList',
    component: () => import('@/views/support/tickets/TicketList.vue'),
    meta: {
      title: 'Tickets de support',
      pageTitle: 'Liste des tickets de support',
      pageDesc: 'Consultez et gérez tous les tickets de support liés à la logistique et à la livraison.',
      icon: 'mdi-lifebuoy',
      accessibility: {
        ariaLabel: 'Liste des tickets de support',
        breadcrumbLabel: 'Fil d\'Ariane de la liste des tickets de support',
      },
      breadcrumb: [
        { text: 'Support', to: { name: 'SupportTicketList' }, ariaLabel: 'Accueil support' },
        { text: 'Liste', active: true, ariaLabel: 'Liste des tickets' },
      ],
      roles: ['admin', 'superadmin', 'manager', 'warehouse_operator', 'customer_support', 'supplier'],
    },
  },
  {
    path: '/support/ticket/:id',
    name: 'SupportTicketDetail',
    component: () => import('@/views/support/tickets/TicketDetail.vue'),
    meta: {
      title: 'Détail du ticket',
      pageTitle: 'Détail du ticket de support',
      pageDesc: 'Visualisez les informations détaillées d\'un ticket de support logistique.',
      hidden: true,
      accessibility: {
        ariaLabel: 'Détail du ticket de support',
        breadcrumbLabel: 'Fil d\'Ariane du détail du ticket',
      },
      breadcrumb: [
        { text: 'Support', to: { name: 'SupportTicketList' }, ariaLabel: 'Accueil support' },
        { text: 'Détail du ticket', active: true, ariaLabel: 'Détail du ticket' },
      ],
      roles: ['admin', 'superadmin', 'manager', 'warehouse_operator', 'customer_support', 'supplier'],
    },
  },
  {
    path: '/support/create',
    name: 'SupportTicketCreate',
    component: () => import('@/views/support/tickets/TicketCreate.vue'),
    meta: {
      title: 'Créer un ticket',
      pageTitle: 'Créer un ticket de support',
      pageDesc: 'Soumettez une nouvelle demande d’assistance logistique ou livraison.',
      hidden: true,
      roles: ['supplier'],
      requireLogin: true,
      accessibility: {
        ariaLabel: 'Formulaire de création de ticket de support',
        breadcrumbLabel: 'Fil d’Ariane de création de ticket',
      },
      breadcrumb: [
        { text: 'Support', to: { name: 'SupportTicketList' }, ariaLabel: 'Accueil support' },
        { text: 'Créer un ticket', active: true, ariaLabel: 'Créer un ticket' },
      ],
    },
  },
  {
    path: '/support/ticket/:id/edit',
    name: 'SupportTicketEdit',
    component: () => import('@/views/support/tickets/TicketEdit.vue'),
    meta: {
      title: 'Modifier le ticket',
      pageTitle: 'Modifier un ticket de support',
      pageDesc: 'Modifiez les informations d’un ticket de support logistique.',
      hidden: true,
      roles: ['supplier'],
      requireLogin: true,
      accessibility: {
        ariaLabel: 'Formulaire de modification de ticket de support',
        breadcrumbLabel: 'Fil d’Ariane de modification de ticket',
      },
      breadcrumb: [
        { text: 'Support', to: { name: 'SupportTicketList' }, ariaLabel: 'Accueil support' },
        { text: 'Modifier le ticket', active: true, ariaLabel: 'Modifier le ticket' },
      ],
    },
  },
  {
    path: '/support/redelivery-requests',
    name: 'RedeliveryRequestList',
    component: () => import('@/views/support/redelivery-requests/RedeliveryRequestList.vue'),
    meta: {
      title: 'Demandes de nouvelle livraison',
      pageTitle: 'Liste des demandes de nouvelle livraison',
      pageDesc: 'Consultez et gérez les demandes de relivraison pour les colis logistiques.',
      icon: 'mdi-refresh',
      roles: ['admin', 'superadmin', 'manager', 'warehouse_operator', 'customer_support', 'supplier'],
      requireLogin: true,
      accessibility: {
        ariaLabel: 'Liste des demandes de nouvelle livraison',
        breadcrumbLabel: 'Fil d\'Ariane des demandes de nouvelle livraison',
      },
      breadcrumb: [
        { text: 'Support', to: { name: 'SupportTicketList' }, ariaLabel: 'Accueil support' },
        { text: 'Demandes de nouvelle livraison', active: true, ariaLabel: 'Demandes de nouvelle livraison' },
      ],
    },
  },
  {
    path: '/support/driver-tickets',
    name: 'support-driver-ticket-list',
    component: () => import('@/views/support/driver-tickets/DriverTicketList.vue'),
    meta: {
      title: 'Réclamations Livreur',
      pageTitle: 'Liste des réclamations livreur',
      pageDesc: 'Consultez et gérez les réclamations des livreurs pour problèmes de livraison.',
      icon: 'mdi-truck-alert',
      roles: ['admin', 'superadmin', 'manager', 'warehouse_operator', 'customer_support', 'driver'],
      requireLogin: true,
      accessibility: {
        ariaLabel: 'Liste des réclamations livreur',
        breadcrumbLabel: 'Fil d\'Ariane des réclamations livreur',
      },
      breadcrumb: [
        { text: 'Support', to: { name: 'SupportTicketList' }, ariaLabel: 'Accueil support' },
        { text: 'Réclamations Livreur', active: true, ariaLabel: 'Réclamations livreur' },
      ],
    },
  },
  {
    path: '/support/driver-tickets/:id',
    name: 'DriverTicketDetail',
    component: () => import('@/views/support/driver-tickets/DriverTicketDetail.vue'),
    meta: {
      title: 'Détail de la réclamation livreur',
      pageTitle: 'Détail de la réclamation livreur',
      pageDesc: 'Visualisez les informations détaillées d\'une réclamation livreur.',
      hidden: true,
      roles: ['admin', 'superadmin', 'manager', 'warehouse_operator', 'customer_support', 'driver'],
      requireLogin: true,
      accessibility: {
        ariaLabel: 'Détail de la réclamation livreur',
        breadcrumbLabel: 'Fil d’Ariane du détail de la réclamation',
      },
      breadcrumb: [
        { text: 'Support', to: { name: 'SupportTicketList' }, ariaLabel: 'Accueil support' },
        { text: 'Réclamations Livreur', to: { name: 'support-driver-ticket-list' }, ariaLabel: 'Réclamations livreur' },
        { text: 'Détail', active: true, ariaLabel: 'Détail de la réclamation' },
      ],
    },
  },
]
